<template>
  <transition-group name="block-swap" tag="div" class="build-grid" aria-hidden="true">
    <div
      v-for="block in blocks"
      :key="block.id"
      :class="['build-block', { rotating: block.id === rotatingBlockId }]"
      :style="{ '--block-accent': block.color }"
    >
      <v-icon v-if="block.icon" color="white" size="22">{{ block.icon }}</v-icon>
    </div>
  </transition-group>
</template>

<script>
const blockColors = ["#006c27", "#168442", "#1d9bb2", "#5a9e6c", "#fccf46"];
const blockIcons = {
  0: "mdi-shield-check",
  2: "mdi-key-variant",
  4: "mdi-api",
  6: "mdi-arrow-top-right",
  8: "mdi-openid",
};

export default {
  name: "ApplicationBuildAnimation",
  props: {
    progressStep: Number,
  },
  data() {
    return {
      blocks: Array.from({ length: 9 }, (_, index) => ({
        id: index + 1,
        icon: blockIcons[index] || "",
        color: blockColors[0],
      })),
      rotatingBlockId: null,
      rotationTimer: null,
      rotationClearTimer: null,
      rotationCount: 0,
    };
  },
  watch: {
    progressStep() {
      const block = this.blocks[this.randomIndex(this.blocks.length)];
      block.color = blockColors[(this.progressStep + 1) % blockColors.length];
    },
  },
  mounted() {
    this.rotationTimer = setInterval(this.rotateRandomBlock, 1150);
  },
  beforeDestroy() {
    clearInterval(this.rotationTimer);
    clearTimeout(this.rotationClearTimer);
  },
  methods: {
    randomIndex(length) {
      return Math.floor(Math.random() * length);
    },
    rotateRandomBlock() {
      const block = this.blocks[this.randomIndex(this.blocks.length)];
      this.rotatingBlockId = block.id;
      this.rotationClearTimer = setTimeout(() => {
        this.rotatingBlockId = null;
      }, 820);
      this.rotationCount += 1;
      if (this.rotationCount % 4 === 0) {
        this.swapBlocks();
      }
    },
    swapBlocks() {
      const first = this.randomIndex(this.blocks.length);
      let second = this.randomIndex(this.blocks.length);
      while (second === first) {
        second = this.randomIndex(this.blocks.length);
      }
      const nextBlocks = [...this.blocks];
      [nextBlocks[first], nextBlocks[second]] = [nextBlocks[second], nextBlocks[first]];
      this.blocks = nextBlocks;
    },
  },
};
</script>

<style scoped>
.build-grid {
  display: grid;
  grid-template-columns: repeat(3, 52px);
  gap: 10px;
  justify-content: center;
  margin: 8px auto 30px;
}

.build-block {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, var(--block-accent) 130%);
  box-shadow: 5px 7px 0 rgba(0, 73, 31, 0.14);
  transition: background 550ms ease-in-out, box-shadow 550ms ease-in-out;
}

.build-block.rotating {
  animation: block-turn 820ms ease-in-out;
}

.block-swap-move {
  transition: transform 700ms ease-in-out;
}

@keyframes block-turn {
  0% {
    transform: rotateY(0deg) scale(1);
  }
  50% {
    transform: rotateY(180deg) scale(1.12);
  }
  100% {
    transform: rotateY(360deg) scale(1);
  }
}
</style>
